<template>
  <div class="mt-2">
    <span> {{ i18n.t('public.events.rsvp_form.shifts.label') }} </span>

    <shifts-checkboxes :shifts-by-day="shiftsByDay" :initial-selected-shift-ids="initialSelectedShiftIds"
                       @changed="(newValue) => $emit('changed', newValue)">
      <template v-if="showDaysForShifts" #day-label="{ label }">
        <h4 class="mt-2 mb-2">
          {{ label }}
        </h4>
      </template>
    </shifts-checkboxes>

    <validation-errors v-if="validationErrors.length" :errors="validationErrors" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ShiftsCheckboxes from '@/components/inputs/shifts-checkboxes'
import ValidationErrors from '@/components/inputs/validation-errors.vue'

export default {
  components: { ShiftsCheckboxes, ValidationErrors },

  props: {
    initialSelectedShiftIds: {
      type: Array,
      required: false,
      default: () => []
    },

    shifts: {
      type: Array,
      required: true
    },

    showDaysForShifts: {
      type: Boolean,
      required: true
    },

    validationErrors: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  emits: ['changed'],

  computed: {
    ...mapGetters(['shiftsByDay'])
  }
}
</script>
